import { render, staticRenderFns } from "./NR1SavedDashboard.vue?vue&type=template&id=3c9044b9&scoped=true&"
import script from "./NR1SavedDashboard.vue?vue&type=script&lang=js&"
export * from "./NR1SavedDashboard.vue?vue&type=script&lang=js&"
import style0 from "./NR1SavedDashboard.vue?vue&type=style&index=0&id=3c9044b9&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3c9044b9",
  null
  
)

export default component.exports